import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import UserContact from '../UserContact';
import Icon from '../Icon';

const MainWrapper = styled.div`
  margin: auto;
  max-width: ${rem('1232px')};
  ${mediaqueries.greaterThan('mobile')`
    padding: 0 ${rem('24px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding: 0;
    width: 100%;
  `};
`;

const WrapperBox = styled.div`
  display: flex;
  margin-bottom: ${rem('10px')};
  justify-content: space-between;
  align-items: start;
  flex-direction: column;
  ${mediaqueries.greaterThan('desktop')`
    margin-bottom:${rem('16px')};
    flex-direction: row;
  `};
`;

const BoxSummary = styled.div`
  margin-bottom: ${rem('46px')};
  padding: 0 ${rem('16px')};
  width: 100%;
  ${mediaqueries.greaterThan('mobile')`
    padding: 0;
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin-right: ${rem('81px')};
  `};
`;

const Title = styled.h2`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('15px')};
  margin: 0 0 ${rem('16px')} 0;
  text-transform: uppercase;
  display: flex;
  ${mediaqueries.greaterThan('mobile')`
    font-size: ${props => props.theme.fontSize.xlarge};
    padding: 0;
  `};
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('16px')};
    margin: 0 0 ${rem('17px')} 0;
  `};
`;

const Contact = styled(UserContact)`
  flex-basis: 100%;
  margin-bottom: ${rem('20px')};
  ${mediaqueries.greaterThan('desktop')`
    flex: 0 0 ${rem('348px')};
  `};
`;

const StyleEditIcon = styled(Icon)`
  margin-left: 15px;
  display: inline-block;
`;

const StyledContact = styled.div`
  width: 100%;
  ${mediaqueries.greaterThan('desktop')`
    max-width: ${rem('645px')};
    width: auto;
  `};
`;

export {
  MainWrapper,
  WrapperBox,
  BoxSummary,
  Title,
  Contact,
  StyleEditIcon,
  StyledContact
};
